import React from 'react';
import { useWeb3Modal } from '@web3modal/ethers5/react';

const WalletDisplay = ({ address }) => {
    const { open } = useWeb3Modal();

    if (!address) return null;

    const shortenAddress = (addr) => {
        return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
    };

    const handleDisconnectClick = async () => {
        await open({ view: 'Account' });
    };

    return (
        <div className="inline-flex items-center gap-2 bg-background/50 backdrop-blur-sm rounded-lg px-3 py-1.5 border border-primary/20">
            <div className="h-2 w-2 bg-green-500 rounded-full animate-pulse" />
            <span className="text-sm font-mono text-primary">{shortenAddress(address)}</span>
            <div className="w-px h-4 bg-primary/20" />
            <button
                onClick={handleDisconnectClick}
                className="text-sm text-primary hover:text-accent transition-colors"
            >
                Disconnect
            </button>
        </div>
    );
};

export default WalletDisplay;